<template>
  <page>
    <div slot="pageAction">
      <div class="actionBlock">
        <v-menu offset-y :min-width="250">
          <template v-slot:activator="{ on }">
            <v-btn text color="secondary" v-on="on">
              Related Tasks
              <v-icon right>mdi-link</v-icon>
            </v-btn>
          </template>
          <side-function-menu :items="sideFunction" @doClick="$router.push($event)"></side-function-menu>
        </v-menu>
      </div>
    </div>
  </page>
</template>

<script>
import SideFunctionMenu from '@/components/core/claimManagement/sideFunction/SideFunctionMenu'

export default {
  data() {
    return {
      sideFunction: [
        {
          text: 'Clause',
          icon: 'mdi-tune',
          iconColor: 'primary',
          params: { name: 'clause' }
        },
        {
          text: 'Default Text',
          icon: 'mdi-tune',
          iconColor: 'primary',
          params: { name: 'defText' }
        },
        {
          text: 'Document Heading Text',
          icon: 'mdi-tune',
          iconColor: 'primary',
          params: { name: 'docHdgTxtList' }
        },
        {
          text: 'Document No. Format',
          icon: 'mdi-tune',
          iconColor: 'primary',
          params: { name: 'docNoForm' }
        },
        {
          text: 'Seq No., Various',
          icon: 'mdi-tune',
          iconColor: 'primary',
          params: { name: 'docNoSeq' }
        },
        {
          text: 'Standard Risk Text',
          icon: 'mdi-tune',
          iconColor: 'primary',
          params: { name: 'stdRiskTxtList' }
        }
      ]
    }
  },
  mounted() {
    this.doInitRelatedLinks()
  },
  methods: {
    // CBO: Added to resolved loading issue 16/Oct
    async doInitRelatedLinks() {
      await Promise.all([this.$store.dispatch('stdRiskTxtManagementInit')])
      await Promise.all([this.$store.dispatch('docHdgTxtManagementInit')])
    }
  },
  components: {
    SideFunctionMenu
  }
}
</script>
